import { SearchIcon } from '../SearchIcons'

interface GlobalSearchStatusProps {
  query: string
  isPreview: boolean
  isLoading: boolean
  hasSections: boolean
  /** The empty search's Values tab, which explains itself instead of listing anything. */
  showValuesPreviewTip: boolean
}

/** What the result list says while it has no sections: loading, a tip, or no matches. */
export function GlobalSearchStatus({
  query,
  isPreview,
  isLoading,
  hasSections,
  showValuesPreviewTip,
}: GlobalSearchStatusProps) {
  if (hasSections) return null

  return (
    <>
      {isLoading && (
        <div className="flex h-full min-h-[240px] flex-col items-center justify-center gap-2 px-4 text-center">
          <span
            className="h-5 w-5 animate-spin rounded-full border-2 border-[color:var(--border-info)] border-t-transparent"
            aria-hidden="true"
          />
          <p className="text-muted text-xs">Searching...</p>
        </div>
      )}

      {!isLoading && showValuesPreviewTip && (
        <div className="flex h-full min-h-[320px] flex-col items-center justify-center px-4 text-center">
          <span
            className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[color:var(--bg-muted)] text-muted"
            aria-hidden="true"
          >
            <SearchIcon className="h-5 w-5" />
          </span>
          <p className="text-default text-sm font-medium">
            Search to find specific values from any cell
          </p>
          <p className="mt-1 text-xs text-muted">Names, numbers, dates, and more...</p>
        </div>
      )}

      {!isLoading && isPreview && !showValuesPreviewTip && (
        <div className="px-4 py-10 text-center">
          <p className="text-muted text-sm">Start typing to search across everything.</p>
        </div>
      )}

      {!isLoading && query.trim().length > 0 && (
        <div className="px-4 py-10 text-center">
          <p className="text-subtle text-sm">No matches for &quot;{query}&quot;</p>
        </div>
      )}
    </>
  )
}
